export default __webpack_public_path__ + "static/media/user_avatar_1.1d6a4084.png";